(() => {
  const tree = window.partFinderTree || { roots: [] };
  const rootEl = document.querySelector('[data-partfinder-root]');
  if (!rootEl) return;

  const selectElements = {
    level1: rootEl.querySelector('[data-partfinder-select="level1"]'),
    level2: rootEl.querySelector('[data-partfinder-select="level2"]'),
    level3: rootEl.querySelector('[data-partfinder-select="level3"]')
  };

  const feedbackEl = rootEl.querySelector('[data-partfinder-feedback]');
  const searchButtons = rootEl.querySelectorAll('[data-partfinder-search]');
  const resetButtons = rootEl.querySelectorAll('[data-partfinder-reset]');

  const findNode = (handle, nodes) => {
    if (!handle || !Array.isArray(nodes)) return null;
    for (const node of nodes) {
      if (node.handle === handle) return node;
      const deeper = findNode(handle, node.children || []);
      if (deeper) return deeper;
    }
    return null;
  };

  const populateSelect = (select, nodes, placeholder) => {
    if (!select) return;
    const currentValue = select.value;
    select.innerHTML = '';

    const placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = placeholder;
    select.appendChild(placeholderOption);

    nodes.forEach((node) => {
      if (!node) return;
      const option = document.createElement('option');
      option.value = node.handle;
      option.textContent = node.title || node.handle;
      select.appendChild(option);
    });

    select.disabled = nodes.length === 0;
    if (!select.disabled && nodes.some((node) => node.handle === currentValue)) {
      select.value = currentValue;
    } else {
      select.value = '';
    }
  };

  const clearFeedback = () => {
    if (feedbackEl) {
      feedbackEl.textContent = '';
      feedbackEl.classList.remove('is-error');
    }
  };

  const setFeedback = (message) => {
    if (!feedbackEl) return;
    feedbackEl.textContent = message;
    feedbackEl.classList.add('is-error');
  };

  const updateLevel2 = () => {
    clearFeedback();
    const selectedHandle = selectElements.level1?.value;
    if (!selectedHandle) {
      populateSelect(selectElements.level2, [], selectElements.level2?.options?.[0]?.textContent || 'Select an option');
      populateSelect(selectElements.level3, [], selectElements.level3?.options?.[0]?.textContent || 'Select an option');
      return;
    }
    const node = findNode(selectedHandle, tree.roots);
    const children = node?.children || [];
    populateSelect(selectElements.level2, children, selectElements.level2?.options?.[0]?.textContent || 'Select an option');
    populateSelect(selectElements.level3, [], selectElements.level3?.options?.[0]?.textContent || 'Select an option');
  };

  const updateLevel3 = () => {
    clearFeedback();
    const selectedHandle = selectElements.level2?.value;
    if (!selectedHandle) {
      populateSelect(selectElements.level3, [], selectElements.level3?.options?.[0]?.textContent || 'Select an option');
      return;
    }
    // Find the level 1 node first
    const level1Handle = selectElements.level1?.value;
    if (!level1Handle) {
      populateSelect(selectElements.level3, [], selectElements.level3?.options?.[0]?.textContent || 'Select an option');
      return;
    }
    const level1Node = findNode(level1Handle, tree.roots);
    if (!level1Node) {
      populateSelect(selectElements.level3, [], selectElements.level3?.options?.[0]?.textContent || 'Select an option');
      return;
    }
    // Find the level 2 node from level 1's children
    const level2Node = findNode(selectedHandle, level1Node.children || []);
    const children = level2Node?.children || [];
    populateSelect(selectElements.level3, children, selectElements.level3?.options?.[0]?.textContent || 'Select an option');
  };

  const handleSearch = () => {
    clearFeedback();
    const preferredHandle =
      selectElements.level3?.value ||
      selectElements.level2?.value ||
      selectElements.level1?.value;

    if (!preferredHandle) {
      setFeedback(window.partFinderMessages?.chooseOption || 'Please select at least one option to continue.');
      return;
    }

    const node = findNode(preferredHandle, tree.roots);
    if (node?.url) {
      window.location.href = node.url;
      return;
    }

    setFeedback(window.partFinderMessages?.missingUrl || 'Unable to open the selected option. Please choose another.');
  };

  const handleReset = () => {
    clearFeedback();
    if (selectElements.level1) {
      selectElements.level1.value = '';
    }
    populateSelect(selectElements.level2, [], selectElements.level2?.options?.[0]?.textContent || 'Select an option');
    populateSelect(selectElements.level3, [], selectElements.level3?.options?.[0]?.textContent || 'Select an option');
  };

  const init = () => {
    if (!selectElements.level1) return;
    populateSelect(
      selectElements.level1,
      tree.roots || [],
      selectElements.level1.options?.[0]?.textContent || 'Select an option'
    );
    populateSelect(
      selectElements.level2,
      [],
      selectElements.level2?.options?.[0]?.textContent || 'Select an option'
    );
    populateSelect(
      selectElements.level3,
      [],
      selectElements.level3?.options?.[0]?.textContent || 'Select an option'
    );

    selectElements.level1?.addEventListener('change', updateLevel2);
    selectElements.level2?.addEventListener('change', updateLevel3);

    searchButtons.forEach((button) => {
      button.addEventListener('click', handleSearch);
    });

    resetButtons.forEach((button) => {
      button.addEventListener('click', handleReset);
    });

    if (!tree.roots || tree.roots.length === 0) {
      setFeedback(window.partFinderMessages?.emptyData || 'No parts are configured for this page yet.');
      if (selectElements.level1) selectElements.level1.disabled = true;
    }
  };

  init();
})();

